<template>
    <div class="form-input-container">
        <div class="form-title"><label>{{translate(label)}} <span class="required" v-if="required">*</span></label></div>
        <div style="display: flex; align-items: center;">
            <datetime type="datetime" v-model="localValue" auto></datetime>
        </div>
    </div>
</template>
<script>
    import { Datetime } from 'vue-datetime';
    export default {
        components: {Datetime},
        props: {
            value: {}, label: {},
            required: {
                type: Boolean,
                default: true
            },
            type: {
                type: String,
                default: "text"
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                localValue: null
            }
        },
        created() {
            this.setFieldValue();
        },
        methods: {
            setFieldValue() {
                this.localValue = this.value;
            }
        },
        watch: {
            localValue(val) {
                this.$emit('input', val);
            },
            value(val) {
                this.setFieldValue();
            },
        },
        computed: {
            model: {
                get() {
                    return this.localValue
                },
                set(value) {
                    if (value.constructor.name.toLowerCase() !== 'inputevent') {
                        this.$nextTick(() => {
                            this.localValue = value
                        })
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .form-input-container {
        margin-bottom: 12px;
    }

    .form-title {
        margin-bottom: 8px;
    }

    /* .vdatetime {
        height: 38px;
        border: 2px solid #EEE;
        border-radius: 6px;
        font-family: "Open Sans", "Hanuman", sans-serif;
    } */
</style>


// WEBPACK FOOTER //
// src/components/Forms/Datetime.vue